import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Deactivate",
  "use": "icon-Deactivate-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-Deactivate\">\r\n  <circle id=\"icon-Deactivate_椭圆_21\" data-name=\"椭圆 21\" cx=\"4\" cy=\"4\" r=\"4\" fill=\"#c3c5cc\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol